import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ContactRelationshipsService, ContactsService } from 'src/app/core/lists';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { GeneralAutocompleteComponent } from '../../../layout/general-autocomplete/general-autocomplete.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-start-focused-view-from-entity',
  templateUrl: './start-focused-view-from-entity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartFocusedViewFromEntityComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  entitySelectForm: FormGroup;
  viewLoading = true;
  loadingAfterSubmit = false;
  getRelationsAutocomplete;
  @ViewChild('relationsAutocomplete') relationsAutocomplete: GeneralAutocompleteComponent;
  constructor(
    private contactsService: ContactsService,
    public dialogRef: MatDialogRef<StartFocusedViewFromEntityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private contactRelationshipsService: ContactRelationshipsService,
    private cdr: ChangeDetectorRef,
    public stringUtils: StringUtilsService,
    private relationshipsService: ContactRelationshipsService,
  ) {}

  ngOnInit() {
    this.getRelationsAutocomplete = this.relationshipsService.searchPatientRelations.bind(
      this.relationshipsService,
      this.data.patientId,
    );
    this.viewLoading = false;
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  save() {
    this.dialogRef.close(this.relationsAutocomplete.value?.contact);
  }
  formatRelationOption(relation: any): string {
    return relation?.contact ? `${relation.contact.first_name} ${relation.contact.last_name}` : '';
  }
}
